export default __webpack_public_path__ + "static/media/nas-logo.2b085e32.png";